import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';
import * as types from '../constants/actionTypes';
import { CATEGORY_ID, MEMBER_SEARCH_SCREEN } from '../constants/category';
import { PAGING_DEFAULT, STATUS_RESULT_TYPE } from '../constants/constants';
import { utils } from '../functions';
import { generateParamsMemberSearch, generateParamsNicheSearch } from '../functions/utils';
import * as GoogleService from '../services/googleService';
import memberSearchService from '../services/memberSearchService';
import userService from '../services/userService';
import * as myStore from '../store/myStore';
import { updateCommonStateReducerSuccess, updateDataSpotlightModalSuccess } from './commonStateAction';
import { postUserMemberProfileActionSuccess, updateMemberProfileState } from './memberProfileActions';
import { IParamsRequest } from 'redhotpie-shared-lib/interfaces/IAction';
import { IShowMeContentTabData } from 'redhotpie-shared-lib/interfaces/IUtils';

// Action types
interface GetNicheSearchSuccessAction {
  type: string;
  data: any;
}

interface LoadMoreUsersMemberSearchSuccessAction {
  type: string;
  data: any;
  params: any;
}

interface GetUsersMemberSearchSuccessAction {
  type: string;
  data: any;
}

interface GetUsersSpotlightSuccessAction {
  type: string;
  data: any;
}

interface GetListEntitiesSearchSuccessAction {
  type: string;
  categoryId: string;
  data: any;
  params: any;
}

interface UpdateStateMemberSearchAction {
  type: string;
  dataKey: string[];
  data: any;
}

interface UpdateSortOrderTypeAction {
  type: string;
  id: number;
}

interface GetDetailPlaceSuccessAction {
  type: string;
  data: any;
}

interface UpdateMemberSearchAction {
  type: string;
  data: any;
}

interface SetStateEntitiesTabIndexAction {
  type: string;
  categoryId: number;
  index?: number;
  flag: boolean;
}

interface DeleteUserMemberAction {
  type: string;
  data: {
    ids: any;
    isSpotlight: boolean;
  };
}

interface PostUsersMemberSearchProfileSuccessAction {
  type: string;
  data: any;
  params: any;
  isSearchUserName: boolean;
  isSearchSpotlight: boolean;
}

interface GetUserSavedSearchesSuccessAction {
  type: string;
  data: any;
}

// Action creators
export function getNicheSearchSuccess(data: any): GetNicheSearchSuccessAction {
  return { type: types.GET_NICHE_SEARCH_SUCCESS, data };
}

export function loadMoreUsersMemberSearchSuccess(data: any, params: any): LoadMoreUsersMemberSearchSuccessAction {
  return { type: types.LOAD_MORE_USERS_MEMBER_SEARCH_SUCCESS, data, params };
}

export function getUsersMemberSearchSuccess(data: any): GetUsersMemberSearchSuccessAction {
  return { type: types.GET_USERS_MEMBER_SEARCH_SUCCESS, data };
}

export function getUsersSpotlightSuccess(data: any): GetUsersSpotlightSuccessAction {
  return { type: types.GET_USERS_SPOTLIGHT_SUCCESS, data };
}

export function getListEntitiesSearchSuccess(categoryId: string, data: any, params: any): GetListEntitiesSearchSuccessAction {
  return { type: types.GET_LIST_ENTITIES_SUCCESS, categoryId, data, params };
}

export function updateStateMemberSearch({ dataKey, data }: { dataKey: any[]; data: any }): UpdateStateMemberSearchAction {
  return { type: types.UPDATE_STATE_MEMBER_SEARCH, dataKey, data };
}

export function updateSortOrderType(id: number): UpdateSortOrderTypeAction {
  return { type: types.UPDATE_SORT_ORDER_TYPE, id };
}

export function getDetailPlaceSuccess(data: any): GetDetailPlaceSuccessAction {
  return { type: types.GET_DETAILS_PLACE_SUCCESS, data };
}

export function updateMemberSearch(data: any): UpdateMemberSearchAction {
  return { type: types.MS_UPDATE_MEMBER_SEARCH, data };
}

export function setStateEntitiesTabIndex({
  categoryId,
  index,
  flag,
}: {
  categoryId: number;
  index?: number;
  flag: boolean;
}): SetStateEntitiesTabIndexAction {
  return { type: types.SET_STATE_ENTITIES_TAB_INDEX, categoryId, index, flag };
}

export function deleteUserMemberAction({ ids, isSpotlight = false }: { ids: any; isSpotlight?: boolean }): DeleteUserMemberAction {
  return { type: types.DELETE_USER_MEMBER, data: { ids, isSpotlight } };
}

export function postUsersMemberSearchProfileSuccess(
  data: any,
  params: any,
  isSearchUserName: boolean,
  isSearchSpotlight: boolean
): PostUsersMemberSearchProfileSuccessAction {
  return {
    type: types.POST_USERS_MEMBER_SEARCH_SUCCESS,
    data,
    params,
    isSearchUserName,
    isSearchSpotlight,
  };
}

export function resetFilterSearch() {
  return (dispatch: any) => {
    dispatch({ type: types.RESET_FILTER_MEMBER_SEARCH });
  };
}

export function resetPremiumFilter() {
  return (dispatch: any) => {
    dispatch({ type: types.RESET_PREMIUM_FILTER });
  };
}

export function resetSearchFilter() {
  return (dispatch: any) => {
    dispatch({ type: types.RESET_SEARCH_FILTER });
  };
}

export function resetSearchSpotlightFilter() {
  return (dispatch: any) => {
    dispatch({ type: types.RESET_SEARCH_SPOTLIGHT_FILTER });
  };
}

export function getUserSavedSearchesSuccess(data: any): GetUserSavedSearchesSuccessAction {
  return { type: types.GET_USER_SAVED_SEARCHES_SUCCESS, data };
}

export function toggleAutoRunHotKey(toggle: boolean) {
  return (dispatch: any) => {
    const params: Record<string, boolean | string | null> = {
      isAutoRunHotKey: false,
      typeAutoRunHotKey: null,
    };
    if (toggle) {
      params.isAutoRunHotKey = true;
      params.typeAutoRunHotKey = MEMBER_SEARCH_SCREEN.ACTION_TYPE.IGNORE;
    }
    dispatch(updateMemberSearch(params));
  };
}

export function postUserMemberSearchActionSuccess(
  user: any,
  index: number,
  actionType: string,
  params: any,
  actionSuccess?: boolean,
  isLikedMutualMatch?: boolean,
  isFavouritedMutualMatch?: boolean,
  message?: string,
  res?: any
): Record<string, any> {
  return {
    type: types.POST_USERS_MEMBER_SEARCH_ACTION_SUCCESS,
    user,
    index,
    actionType,
    params,
    actionSuccess,
    isLikedMutualMatch,
    isFavouritedMutualMatch,
    message,
    res,
  };
}

export function updateUserStatusActionSuccess(data: any): Record<string, any> {
  return { type: types.UPDATE_USER_STATUS, data };
}

export function updateStatusRefineModal(): Record<string, any> {
  return { type: types.UPDATE_REFINE_MODAL_STATUS };
}

export function updateUserClientSafeModeSuccess(safeMode: boolean): Record<string, any> {
  return {
    type: types.UPDATE_USER_LOGIN_STATE,
    data: { dataKey: ['userInfo', 'safeMode'], dataValue: safeMode },
  };
}

export function updateUserClientSpotlightSuccess(value: boolean): Record<string, any> {
  return {
    type: types.UPDATE_USER_LOGIN_STATE,
    data: { dataKey: ['userInfo', 'isSpotlightFeatureEnabled'], dataValue: value },
  };
}

export function setUsersMemberSearch(index: number, user: any, data: any): Record<string, any> {
  return { type: types.SET_IN_USER_MEMBER_SEARCH, index, user, data };
}

export function apisErrorSearch(message: string): Record<string, any> {
  return { type: types.API_ERROR_SEARCH, message };
}

export function resetErrorState() {
  return (dispatch: any) => {
    dispatch({ type: types.RESET_DISCOVERY_ERROR_STATUS });
  };
}

export function getDetailPlaceViaWeb(placeId: string) {
  return (dispatch: any) => {
    return GoogleService.getDetailPlaceViaWeb(placeId).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(getDetailPlaceSuccess(res.data));
      } else {
        console.log('Error: memberSearchActions/getDetailPlace', res.message);
      }
      return res;
    });
  };
}

export function getPlaceDetailFromGeoLocation(lat: number, lng: number, suburb: boolean) {
  return (dispatch: any) => {
    return GoogleService.getPlaceDetailFromGeoLocationV1(lat, lng, suburb).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(getDetailPlaceSuccess(res.data));
      } else {
        console.log('Error: memberSearchActions/getPlaceDetailFromGeoLocation', res.message);
      }
      return res;
    });
  };
}

export const getNicheSearch = () => (dispatch: any) => {
  memberSearchService.getNicheSearch().then((res: IApiResponse) => {
    if (res.success) {
      dispatch(getNicheSearchSuccess(res.data));
    } else {
      console.warn('ERROR: memberSearchActions/getNicheSearch', res.message);
    }
  });
};

export function getSpotlightMember({ pageNumber = 1, pageSize = PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH }: IParamsRequest) {
  return (dispatch: any, getState: any) => {
    dispatch(
      updateMemberSearch({
        isLoadingSpotlightMember: true,
        pageNumberSpotlight: pageNumber ? pageNumber : 1,
      })
    );
    return memberSearchService.getSpotlightMember({ pageNumber, pageSize }).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(getUsersSpotlightSuccess(res));
      } else {
        console.log('Error: memberSearchActions/getSpotlightMember', res.message);
      }
      return res;
    });
  };
}

export function getUsersMemberSearchProfile(params: any) {
  return (dispatch: any, getState: any) => {
    const pageNum = (params as any)?.page || 1;
    dispatch(
      updateMemberSearch({
        isLoadingMatching: true,
        pageNumber: pageNum,
        fetchingSearch: true,
        users: [],
      })
    );
    return userService.getUsersProfileMemberSearch(params).then((res: IApiResponse) => {
      if (res.success) {
        if (res.data.sorting) {
          const orderByType = getState().memberSearchReducer.filters.orderByType.map((item: any) => ({
            ...item,
            isCheck: item.value === res.data.sorting,
          }));
          dispatch(
            updateStateMemberSearch({
              dataKey: ['filters', 'orderByType'],
              data: orderByType,
            })
          );
        }
        dispatch(getUsersMemberSearchSuccess(res.data));
      } else {
        dispatch(apisErrorSearch(res.message || ''));
        console.warn('ERROR: memberSearchActions/getUsers', res.message);
      }
      return res;
    });
  };
}

export function postUsersMemberSearchProfile(state: any, params: any, nicheData?: any, isSearchUserName?: boolean) {
  return (dispatch: any) => {
    let updateParams: Record<string, any> = {};
    let checkedOrderByType: any[] = [];
    let lastSearchType: any = {};
    let isSearchActiveNow = false;
    const currentTab = state.filters?.orderByType?.filter?.((item: any) => item.isCheck) || [];
    const isSearchSpotlight = currentTab?.[0]?.id === MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.SPOT_LIGHT || false;

    if (isSearchUserName) {
      updateParams = {
        usersSearchUserName: [],
        isLoadingSearchUserName: true,
        isHasMoreSearchUserName: true,
        isLoadingMoreSearchUserName: false,
      };
    } else {
      checkedOrderByType = state.filters && state.filters.orderByType && state.filters.orderByType.filter((item: any) => item.isCheck);
      lastSearchType = checkedOrderByType && checkedOrderByType[0] && checkedOrderByType[0].id;
      updateParams = {
        users: [],
        isLoading: true,
        fetchingFiltersSearch: true,
        isShowExpandSearch: false,
        isHasMore: true,
        isLoadingMore: false,
        memberViewProfile: null,
      };
      switch (currentTab[0].id) {
        case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEAR_BY:
          updateParams.isLoadingNearby = true;
          break;
        case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MEMBER_LEVEL:
          updateParams.isLoadingAll = true;
          break;
        case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MATCHING:
          updateParams.isLoadingMatching = true;
          break;
        case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.NEWEST:
          updateParams.isLoadingNew = true;
          break;
        case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE:
          updateParams.isLoadingActive = true;
          break;
        case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.TRAVELLING:
          updateParams.isLoadingTravel = true;
          break;
        case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.ACTIVE_NOW:
          updateParams.isLoadingActiveNow = true;
          isSearchActiveNow = true;
          break;
        case MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.SPOT_LIGHT:
          updateParams.isLoadingSpotlightMember = true;
          break;
        default:
          break;
      }
    }
    dispatch(updateMemberSearch({ ...updateParams }));

    let bodyParams: Record<string, any> = {};
    if (!state && params && nicheData.value && nicheData.value.searchSetting) {
      bodyParams = generateParamsNicheSearch(nicheData.value.searchSetting);
    } else {
      const {
        loginReducer: { userInfo },
        memberSearchReducer: { filters, filtersSpotlight },
      } = myStore.getStore().getState();
      const currFilters = isSearchSpotlight ? filtersSpotlight : filters;
      const currFiltersKey = isSearchSpotlight ? 'filtersSpotlight' : 'filters';
      let newState = { ...state };
      if (currFiltersKey === 'filtersSpotlight') {
        delete newState.filters;
        newState.filters = { ...currFilters, orderByType: state.filters.orderByType };
        newState.showMeMemberType = currFilters.showMeMemberType;
      } else {
        delete newState.filtersSpotlight;
      }
      if (!currFilters?.location?.placeId && !currFilters?.location?.GoogleMapPlacesId) {
        const placeId = userInfo.locationInfo.state.GoogleMapPlacesId || userInfo.locationInfo.suburb.GoogleMapPlacesId;
        newState = {
          ...newState,
          filters: {
            ...newState.filters,
            location: {
              ...state[currFiltersKey].location,
              GoogleMapPlacesId: placeId,
            },
          },
        };
      }
      bodyParams = {
        Type: 'Advanced',
        ...generateParamsMemberSearch({ checkedOrderByType, ...newState }),
      };
    }
    return memberSearchService
      .postUsersMemberSearchProfile({ ...params, ...bodyParams }, isSearchUserName || false, isSearchActiveNow, isSearchSpotlight)
      .then((res: IApiResponse) => {
        try {
          if (res.success) {
            dispatch(
              postUsersMemberSearchProfileSuccess(
                res.data,
                {
                  ...bodyParams,
                  lastSearchType,
                },
                isSearchUserName || false,
                isSearchSpotlight
              )
            );

            return res.data;
          }
          if (res.message) {
            dispatch(apisErrorSearch(res.message));
          }
          dispatch(
            postUsersMemberSearchProfileSuccess(
              res.data,
              {
                ...bodyParams,
                lastSearchType,
              },
              isSearchUserName || false,
              false
            )
          );
          console.warn('ERROR: memberSearchActions/postUsersMemberSearchProfile', res.message);
          return res.data;
        } catch (e) {
          throw new Error('fail');
        }
      });
  };
}

export function loadMoreUsersMemberSearchProfile(params: IParamsRequest) {
  return (dispatch: any) => {
    dispatch(updateMemberSearch({ isLoadingMore: true, fetchingLoadMore: true }));
    return userService.getUsersProfileMemberSearch(params).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(loadMoreUsersMemberSearchSuccess(res.data, params));
      } else {
        dispatch(apisErrorSearch(res.message || ''));
        console.warn('ERROR: memberSearchActions/loadmoreUsers', res.message);
      }
      return res;
    });
  };
}

export function getListEntitiesSearch(categoryId: string, params: IParamsRequest) {
  return (dispatch: any) => {
    return memberSearchService.getListEntitiesSearch(categoryId, params).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(getListEntitiesSearchSuccess(categoryId, res.data, params));
      } else {
        console.warn('ERROR: memberSearchActions/getListEntitiesSearch', res.message);
      }
      return res;
    });
  };
}

export function postUserMemberSearchAction(
  user: any,
  index: number,
  actionType: string,
  params: any,
  dataKey?: string,
  fromProfileIndex?: number
) {
  return (dispatch: any, getState: any) => {
    const {
      memberProfileReducer,
      commonStateReducer: { dataSpotlightModal },
    } = getState();
    const { userId } = user && user.detail ? user.detail : user;
    let isFavMutual = false;
    let isLikMutual = false;
    const memberProfile = memberProfileReducer[userId];
    let profileIntersectionOld = memberProfile?.profileIntersection;
    if (!profileIntersectionOld) {
      profileIntersectionOld = user.profileIntersection;
    }

    if (profileIntersectionOld && actionType === MEMBER_SEARCH_SCREEN.ACTION_TYPE.LIKE) {
      isFavMutual = profileIntersectionOld.isFavoritedMutual;
      isLikMutual = profileIntersectionOld.isLikedMutual;
    }
    const bodyParams: Record<string, unknown> = {
      Id: params && (params as any).userId ? (params as any).userId : null,
      dataKey,
      fromProfileIndex,
      isOnlyFavourite: profileIntersectionOld?.isLiked || false,
    };
    if (params && (params as any).type) {
      bodyParams.Id = user.detail.userId;
      bodyParams.Type = params && (params as any).type ? (params as any).type : actionType;
    }
    if (actionType === MEMBER_SEARCH_SCREEN.ACTION_TYPE.IGNORE) {
      dispatch(postUserMemberSearchActionSuccess(user, index, actionType, bodyParams, false, false, false, ''));
    } else {
      dispatch(
        postUserMemberSearchActionSuccess(user, index, actionType, bodyParams, true, isLikMutual, isFavMutual, 'Not from APIs response')
      );
      dispatch(updateMemberSearch({ allowUserActions: false }));
    }

    return memberSearchService.postUserMemberSearchAction(user.detail.userId, index, actionType, bodyParams).then((res: IApiResponse) => {
      if (res.success) {
        const { LIKE, FAVORITE, UNLIKE, IGNORE } = MEMBER_SEARCH_SCREEN.ACTION_TYPE;
        if (actionType !== IGNORE) {
          let newActionType = actionType;
          let newLikeMutual = (res.data && res.data.isLikedMutualMatch) || false;
          let newFavMutual = (res.data && res.data.isFavouritedMutualMatch) || false;
          if (
            res.data &&
            ((res.data.remainingFavourites === 0 && (params as any).type === FAVORITE) ||
              (res.data.remainingLikes === 0 && (params as any).type === LIKE)) &&
            res.data.resultType === STATUS_RESULT_TYPE.SEND_LIMIT
          ) {
            newActionType = UNLIKE;
            newLikeMutual = isLikMutual;
            newFavMutual = isFavMutual;
          }

          dispatch(postUserMemberProfileActionSuccess(user, index, newActionType, bodyParams, true, newLikeMutual, newFavMutual));

          if (dataSpotlightModal.length > 0) {
            if (newActionType === LIKE) {
              profileIntersectionOld = {
                ...profileIntersectionOld,
                isFavorited: (bodyParams.Type as any) === FAVORITE && newActionType === LIKE,
                isFavoritedMutual: newFavMutual,
                isLiked: newActionType === LIKE,
                isLikedMutual: newFavMutual ? newFavMutual : newLikeMutual,
              };
            }
            if (newActionType === UNLIKE) {
              if ((bodyParams.Type as any) === FAVORITE) {
                profileIntersectionOld = {
                  ...profileIntersectionOld,
                  isFavorited: false,
                  isFavoritedMutual: false,
                };
                if (!(bodyParams.isOnlyFavourite as any)) {
                  const updateObject: Record<string, boolean> = {};
                  updateObject.isLiked = false;
                  updateObject.isLikedMutual = false;
                }
              } else {
                profileIntersectionOld = {
                  ...profileIntersectionOld,
                  isLiked: false,
                  isLikedMutual: false,
                };
              }
            }
          }
          dispatch(updateDataSpotlightModalSuccess(userId, { profileIntersection: profileIntersectionOld }));
        } else {
          if (dataSpotlightModal.length > 0) {
            const newData = dataSpotlightModal.filter((itm: any) => itm.detail.userId !== user.detail.userId);
            dispatch(updateCommonStateReducerSuccess({ dataSpotlightModal: newData }));
          }
        }

        if (res.data) {
          dispatch(
            updateUserStatusActionSuccess({
              ...res.data,
              type: params && (params as any).type ? (params as any).type : actionType,
            })
          );
        }
      } else {
        if (res.data) {
          dispatch(
            updateUserStatusActionSuccess({
              ...res.data,
              type: params && (params as any).type ? (params as any).type : actionType,
            })
          );
        }
        dispatch(
          postUserMemberSearchActionSuccess(
            user,
            index,
            MEMBER_SEARCH_SCREEN.ACTION_TYPE.UNLIKE,
            bodyParams,
            true,
            isLikMutual,
            isFavMutual,
            'Not from APIs response'
          )
        );
        console.warn('ERROR: memberSearchActions/postUserMemberSearchAction', res.message);
      }
      dispatch(updateMemberSearch({ allowUserActions: true }));
      return res;
    });
  };
}

export function postIgnoreUsermemberSearchAction(
  user: any,
  index: number,
  actionType: string,
  params: any,
  dataKey?: string,
  fromProfileIndex?: number
) {
  return () => {
    let bodyParams: Record<string, any> | null = null;
    if (params && (params as any).type) {
      bodyParams = {
        Id: user.detail.userId,
        Type: params && (params as any).type ? (params as any).type : actionType,
        dataKey,
        fromProfileIndex,
      };
    } else {
      bodyParams = {
        Id: params && (params as any).userId ? (params as any).userId : null,
        dataKey,
        fromProfileIndex,
      };
    }

    return memberSearchService.postUserMemberSearchAction(user.detail.userId, index, actionType, bodyParams).then((res: IApiResponse) => {
      if (!res.success) {
        console.warn('ERROR: memberSearchActions/postUserMemberSearchAction', res.message);
      }
      return res;
    });
  };
}

export function patchUserClientSettings() {
  return (dispatch: any, getState: any) => {
    const loginReducer = getState().loginReducer;
    const params = { SafeMode: !loginReducer.userInfo.safeMode };
    return userService.patchUserClientSettings(params).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(updateUserClientSafeModeSuccess(res.data.SafeMode));
        dispatch(
          updateMemberProfileState({
            isShowSafeModeNotify: true,
            isShowSafeModeConfig: false,
          })
        );
      } else {
        console.warn('ERROR: memberSearchActions/patchUserClientSettings', res.message);
      }
      return res;
    });
  };
}

export function patchUserClientSettingsSpotlight() {
  return (dispatch: any, getState: any) => {
    const loginReducer = getState().loginReducer;
    const params = { IsSpotlightFeatureEnabled: !loginReducer.userInfo.isSpotlightFeatureEnabled };
    return userService.patchUserClientSettings(params).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(updateUserClientSpotlightSuccess(res.data.IsSpotlightFeaturedEnabled));
      } else {
        console.warn('ERROR: memberSearchActions/patchUserClientSettingsSpotlight', res.message);
      }
      return res;
    });
  };
}

export function getUserSavedSearches() {
  return (dispatch: any) => {
    return memberSearchService.getUserSavedSearches().then((res: IApiResponse) => {
      if (res.success) {
        dispatch(getUserSavedSearchesSuccess(res.data || []));
      } else {
        console.warn('ERROR: memberSearchActions/getUserSavedSearches', res.message);
      }
      return res;
    });
  };
}

export function postUserSavedSearches(state: any) {
  return (dispatch: any) => {
    let checkedOrderByType: any[] = [];
    checkedOrderByType = state.filters && state.filters.orderByType && state.filters.orderByType.filter((item: any) => item.isCheck);
    const bodyParams = {
      Title: state.saveSearchTitle,
      Config: {
        Type: 'Advanced',
        ...generateParamsMemberSearch({ checkedOrderByType, ...state }),
      },
    };
    return memberSearchService.postUserSavedSearches(bodyParams).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(getUserSavedSearches());
      } else {
        console.warn('ERROR: memberSearchActions/postUserSavedSearches', res.message);
      }

      return res;
    });
  };
}

export function deleteUserSavedSearches(id: number) {
  return (dispatch: any) => {
    return memberSearchService.deleteUserSavedSearches(id).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(getUserSavedSearches());
      } else {
        console.warn('ERROR: memberSearchActions/deleteUserSavedSearches', res.message);
      }

      return res;
    });
  };
}

export function applySaveFilterSearch(saveSearchItem: any) {
  const { config } = saveSearchItem;
  return (dispatch: any, getState: any) => {
    const { memberSearchReducer, loginReducer } = getState();
    const { filters } = memberSearchReducer;
    let filterUpdate: Record<string, any> = {};
    const newFilter: Record<string, any> = {};
    const newCategory: Record<string, any> = {};
    const entities = {
      ...MEMBER_SEARCH_SCREEN.ENTITIES,
      ...MEMBER_SEARCH_SCREEN.FILTERS_ENTITIES,
      ...MEMBER_SEARCH_SCREEN.FILTER_OTHER_ENTITIES,
    };
    // Update filter
    Object.keys(filters).forEach((key: string) => {
      switch (key) {
        case 'orderByType':
          const newOrderByType: any[] = [];
          filters[key].forEach((itm: any) => {
            newOrderByType.push({ ...itm, isCheck: itm.value === config[key] });
          });
          newFilter[key] = newOrderByType;
          break;
        case 'location':
          const newLocation: Record<string, any> = {
            ...filters.location,
            CountryID: config.countryId,
            PostCodeAllID: config.postCodeAllId,
            StateID: config.stateId,
          };
          if (config.googleMapPlace && Object.prototype.hasOwnProperty.call(config.googleMapPlace, 'placesId')) {
            newLocation.GoogleMapPlacesId = config.googleMapPlace.placesId;
            newLocation.LocationType = config.googleMapPlace.types[0];
            newLocation.Type = config.googleMapPlace.types[0];
            newLocation.placeId = config.googleMapPlace.placesId;
          }
          newFilter[key] = newLocation;
          break;
        case 'niche':
          if (config[key] === 'None') {
            newFilter[key] = null;
          } else {
            newFilter[key] = config[key];
          }
          break;
        default:
          if (Object.prototype.hasOwnProperty.call(config, key)) {
            newFilter[key] = config[key];
          }
      }
    });
    // Update other
    let isSearchPremiumFilters = false;
    Object.entries(entities).forEach((keyEntry: [string, any]) => {
      const name = keyEntry[0];
      let isSexual = false;
      if (memberSearchReducer[name] && memberSearchReducer[name].contentTabs && memberSearchReducer[name].contentTabs[0].data) {
        let arrSelect: any;
        switch (name) {
          case CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE:
            arrSelect = utils.decimalToBinary(config.memberType);
            break;
          case CATEGORY_ID.LTM_LOOKING_FOR:
            arrSelect = utils.decimalToBinary(config.seekingMemberType);
            break;
          case CATEGORY_ID.SEXUAL_INTERESTS:
            const sexInter = config[name];
            const sexPre = config.sexualPreference;
            isSexual = true;
            arrSelect = [
              {
                data: sexInter,
              },
              {
                data: sexPre,
              },
            ];
            break;

          default:
            arrSelect = config[name];
        }
        const newContentTabs: any[] = [];
        let count = 0;
        const isSeekingMemberTypeDefault =
          loginReducer.userInfo.memberType === config.seekingMemberType && name === CATEGORY_ID.LTM_LOOKING_FOR;
        memberSearchReducer[name].contentTabs[0].data.forEach((itm: IShowMeContentTabData) => {
          let isSelected = false;
          if (isSexual) {
            const dataInterest = arrSelect[0].data;
            const dataPre = arrSelect[1].data;

            if (itm.listId === 71 || itm.listId === 72) {
              isSelected = dataInterest.indexOf(itm.id) !== -1 || false;
            } else {
              isSelected = dataPre.indexOf(itm.id) !== -1 || false;
            }
          } else {
            isSelected = (arrSelect && arrSelect.indexOf(itm.id) !== -1) || false;
          }
          if (isSelected) {
            count++;
          }
          newContentTabs.push({ ...itm, active: isSelected });
        });
        if (!arrSelect) {
          console.log('name empty', name);
        }
        newCategory[name] = {
          ...memberSearchReducer[name],
          contentTabs: [
            {
              data: newContentTabs,
            },
          ],
          isSelected: count > 0 && !isSeekingMemberTypeDefault,
          isSelecting: count > 0 && !isSeekingMemberTypeDefault,
        };
        if (!isSearchPremiumFilters && count > 0 && name !== CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE && !isSeekingMemberTypeDefault) {
          isSearchPremiumFilters = true;
        }
      }
    });
    filterUpdate = {
      ...memberSearchReducer,
      filters: {
        ...memberSearchReducer.filters,
        ...newFilter,
        isShowAllSavedSearches: false,
      },
      ...newCategory,
      hasChange: true,
      isSearchFilter: true,
      isSearchPremiumFilters,
      hasChangePremiumFilters: isSearchPremiumFilters,
      applySaveSearch: true,
    };
    dispatch(updateMemberSearch(filterUpdate));
    dispatch(
      postUsersMemberSearchProfile(filterUpdate, {
        Size: PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
      })
    );
  };
}

export function postUserMemberProspectAction(
  user: any,
  index: number,
  actionType: string,
  params: any,
  dataKey?: string,
  fromProfileIndex?: number
) {
  return (dispatch: any, getState: any) => {
    const { memberProfileReducer } = getState();
    const { userId } = user && user.detail ? user.detail : user;
    const profileIntersectionOld = memberProfileReducer[userId] && memberProfileReducer[userId].profileIntersection;
    const bodyParams: Record<string, any> = {
      Id: params && (params as any).userId ? (params as any).userId : null,
      dataKey,
      fromProfileIndex,
      isOnlyFavourite: (profileIntersectionOld && profileIntersectionOld.isLiked) || false,
    };
    if (params && (params as any).type) {
      bodyParams.Id = user.detail.userId;
      bodyParams.Type = params && (params as any).type ? (params as any).type : actionType;
    }
    return memberSearchService.postUserMemberSearchAction(user.detail.userId, index, actionType, bodyParams).then((res: IApiResponse) => {
      return res;
    });
  };
}
